import styled from 'styled-components';
import { getTextPresetCss } from '@optimus-web/common';
import {
    Component,
    Decision,
    getComponentToken,
    SPACING,
    SystemWideBannerVariant,
    TEXT_PRESET_KEY,
} from '@optimus-web/local-tokens';
import theme from '@optimus-web/theme';

const getSystemWideBannerToken = getComponentToken(Component.SystemWideBanner);

const getFinalVariant = (variant: SystemWideBannerVariant, importance?: SystemWideBannerImportance) =>
    importance === 'urgent' ? `${variant}Urgent` : variant;

export type SystemWideBannerImportance = 'critical' | 'urgent';

interface SystemWideBannerContainerProps {
    variant: SystemWideBannerVariant;
    centered?: boolean;
    importance?: SystemWideBannerImportance;
}

export const SystemWideBannerContainer = styled.div<SystemWideBannerContainerProps>`
    display: flex;
    align-items: center;

    padding: 9px ${SPACING[400]}px 10px ${SPACING[200]}px;

    color: ${(props) =>
        getSystemWideBannerToken(Decision.Color, {
            variant: getFinalVariant(props.variant, props.importance),
        })};
    background-color: ${(props) =>
        getSystemWideBannerToken(Decision.BackgroundColor, {
            variant: getFinalVariant(props.variant, props.importance),
        })};

    ${(props) =>
        props.centered &&
        `
        justify-content: center;
    `}
`;

SystemWideBannerContainer.defaultProps = {
    theme,
};

export const SystemWideBannerIconElement = styled.span`
    margin: -2px ${SPACING[200]}px -3px 0;
`;

interface SystemWideBannerTextElementProps {
    variant: SystemWideBannerVariant;
    importance?: SystemWideBannerImportance;
}

export const SystemWideBannerTextElement = styled.span<SystemWideBannerTextElementProps>`
    ${getTextPresetCss(TEXT_PRESET_KEY['200m'])}
    color: ${(props) =>
        getSystemWideBannerToken(Decision.Color, {
            variant: getFinalVariant(props.variant, props.importance),
        })};
`;

SystemWideBannerTextElement.defaultProps = {
    theme,
};
